/**
 * Plugins Chart.js usados en estadísticas del panel admin.
 */
// Custom plugin to display data labels on charts
export const dataLabelsPlugin = {
  id: 'customDataLabels',
  afterDatasetsDraw(chart) {
    const { ctx } = chart;
    
    chart.data.datasets.forEach((dataset, i) => {
      const meta = chart.getDatasetMeta(i);
      if (meta.hidden) {
        return;
      }
      
      meta.data.forEach((element, index) => {
        const value = dataset.data[index];
        if (value === null || value === 0) return;

        ctx.fillStyle = '#3c4043';
        ctx.font = '600 11px sans-serif';
        
        const isHorizontal = meta.controller.options.indexAxis === 'y';
        
        if (isHorizontal) {
          ctx.textAlign = 'left';
          ctx.textBaseline = 'middle';
          ctx.fillText(value, element.x + 5, element.y);
        } else {
          ctx.textAlign = 'center';
          ctx.textBaseline = 'bottom';
          ctx.fillText(value, element.x, element.y - 5);
        }
      });
    });
  }
};